module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', [_c('div', {
    class: _vm.menuClassName
  }, [_c('div', {
    staticClass: "rt-sidebar-menu-header"
  }, [_c('div', {
    staticClass: "rt-sidebar-menu-header-logo",
    on: {
      "click": _vm.logoClickHandler
    }
  }, [_vm._t("header-logo", function() {
    return [_c('div', {
      staticClass: "rt-sidebar-menu-header-logo-img"
    }, [_vm._t("logo", function() {
      return [_c('rt-icon', {
        attrs: {
          "size": 40,
          "img-src": _vm.logo
        }
      })]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "rt-sidebar-menu-header-logo-text"
    }, [_vm._t("logo-text", function() {
      return [_c('img', {
        attrs: {
          "src": _vm.logoText
        }
      })]
    })], 2)]
  })], 2), _vm._v(" "), (_vm.customModelPosition === 'top') ? _c('div', {
    staticClass: "rt-sidebar-menu-header-custom-model"
  }, [_vm._t("custom-model")], 2) : _vm._e(), _vm._v(" "), (_vm.search) ? _c('div', {
    staticClass: "rt-sidebar-menu-header-search"
  }, [(!_vm.isDropdownSearch) ? _c('rt-search', {
    attrs: {
      "placeholder": _vm.$tx('请搜索...', 'xpc.search.pleaseSearch'),
      "type": "dark",
      "more": false,
      "border": false
    },
    on: {
      "on-search": _vm.searchClick
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  }) : _c('rt-input', {
    attrs: {
      "type": "autocomplete",
      "popper-class": "rt-sidebar-menu-header-popper",
      "trigger-on-focus": false,
      "show-suffix-icon": false,
      "highlight-first-item": true,
      "clearable": true,
      "clear-icon-right": 8,
      "value-key": _vm.innerAlias.title,
      "placeholder": _vm.$tx('请搜索...', 'xpc.search.pleaseSearch'),
      "fetch-suggestions": _vm.queryFilter
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  }, [_c('rt-icon', {
    attrs: {
      "slot": "prefix",
      "size": "18",
      "name": "rt-base-lookup"
    },
    slot: "prefix"
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.customModelPosition === 'bottom') ? _c('div', {
    staticClass: "rt-sidebar-menu-header-custom-model"
  }, [_vm._t("custom-model")], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "rt-sidebar-menu-body"
  }, [_c('rt-sidebar-menu-body', {
    attrs: {
      "data-source": _vm.filterMenuList,
      "collapse": _vm.innerCollapse,
      "theme": _vm.theme,
      "default-active": _vm.innerDefaultAction,
      "default-openeds": _vm.innerOpenedsMenu,
      "alias": _vm.innerAlias,
      "search-value": !_vm.isDropdownSearch ? _vm.searchValue : '',
      "active-index": _vm.activeIndex
    },
    on: {
      "select": _vm.selectHandler,
      "open": _vm.openHandler,
      "close": _vm.closeHandler
    }
  })], 1), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "rt-sidebar-menu-footer"
  }, [_vm._t("footer")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rt-sidebar-menu-collapse",
    class: _vm.innerCollapse ? 'arrow-right' : 'arrow-left',
    on: {
      "click": _vm.triggerCollapse
    }
  }, [_c('rt-icon', {
    attrs: {
      "size": 10,
      "name": "rt-base-arrow-right-lined"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-524abf9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/sidebarMenu/src/rtSidebarMenu.vue
// module id = 2144
// module chunks = 137